/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Catalogue_Templates_IntroInputs */



/**
* | output |
* | --- |
* | "Start with a ready-made agent, or build your own." |
*
* @param {Agent_Catalogue_Templates_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_catalogue_templates_intro = /** @type {((inputs?: Agent_Catalogue_Templates_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Catalogue_Templates_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beginnen Sie mit einem fertigen Agenten oder erstellen Sie Ihren eigenen.")
	return /** @type {LocalizedString} */ ("Start with a ready-made agent, or build your own.")
});